import sentry, { featureTags } from '@/services/sentry'

export const captureKeepInkError = (error) => sentry.captureException(error, {
  tags: featureTags({ featureFlag: 'PRE-169-presenter-keep-ink', featureName: 'keep-ink', taskId: 'PRE-169' }),
})
